<template>
  <div class="container videos">
    <div class="columns is-multiline" v-if="videos.length > 0">
      <video-item
        v-for="video in videos"
        :key="video.id"
        :item="video"
        v-on:add-to-playlist="addToPlaylist"
      ></video-item>
    </div>
  </div>
</template>

<script>
import VideoItem from "@/components/playlists/playlistVideoItem.vue";

export default {
  components: {
    VideoItem,
  },
  props: {
    videos: Array,
  },
  methods: {
    addToPlaylist(event) {
      this.$emit("add-to-playlist", event);
    },
  },
};
</script>
